<template>
  <div>
    <q-header elevated>
      <q-toolbar class="toolbar q-px-none bg-accent text-white" style="h">
        <div v-if="!miniState" class="">
          <!-- <q-btn-dropdown
            class="btnDropdown"
            color="accent2"
            flat
            dropdown-icon=" "
          >
            <q-list>
              <q-item
                @click.native="switchSites()"
                class="dropdownLogo q-pa-none"
              >
                <div class="navbarLogo bg-white q-py-md">
                  <p class="text-accent">upstream</p>
                  <p class="text-accent">Social Impact</p>
                </div>
              </q-item>
            </q-list>
          </q-btn-dropdown> -->
          <div class="q-py-sm q-pl-sm" style="margin: 0 60px 0 30px">
            <img
              class="mx-auto"
              src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Oatas+Hero+Logo-03.svg"
              style="width: 112px; height: 38px"
            />
          </div>

          <!-- <div class="navbarLogo q-py-md">
            <p>upstream</p>
            <p>Sustainability Plans</p>
          </div> -->
        </div>

        <div v-else class="row navbarLogoMobile bg-accent2">
          <!-- <q-btn-dropdown
            class="btnDropdownMobile"
            color="accent2"
            flat
            dropdown-icon=" "
          >
            <q-list>
              <q-item
                @click.native="switchSites()"
                class="
                  dropdownLogo
                  q-pa-none
                  bg-accent2
                  justify-center
                  cursor-pointer
                "
              >
                <q-img
                  src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Oatas+Icon-13.svg"
                  alt="Mini logo"
                  width="40px"
                  height="40px"
                  contain
                />
                <q-tooltip
                  anchor="center right"
                  self="center left"
                  :offset="[10, 10]"
                >
                  Social Impact
                </q-tooltip>
              </q-item>
            </q-list>
          </q-btn-dropdown> -->
          <img
            src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Oatas+Icon-13.svg"
            alt="Mini logo"
            class="smallImage q-mx-auto q-my-auto"
            width="40px"
            height="40px"
          />
          <q-tooltip
            anchor="center right"
            self="center left"
            :offset="[10, 10]"
          >
            Sustainability Plans
          </q-tooltip>
        </div>

        <!-- Menu button -->
        <q-btn
          flat
          @click="toggleNav()"
          round
          dense
          color="white"
          icon="menu"
          class="q-mx-sm"
        ></q-btn>

        <div class="row">
          <!-- Account section -->
          <div>
            <!-- Text -->
            <div @click="accMenuToggle = true">
              <q-list>
                <q-item class="row items-center accText">
                  <q-item-section avatar>
                    <q-avatar size="30px">
                      <img
                        :src="
                          currentUserData.profilePictureUrl
                            ? currentUserData.profilePictureUrl
                            : currentUserData.picture
                        "
                      />
                    </q-avatar>
                  </q-item-section>

                  <q-item-section>
                    <q-item-label>
                      {{ currentUserData.fullName }}
                    </q-item-label>
                    <q-item-label
                      class="userRole"
                      caption
                      lines="1"
                      v-if="currentUserData"
                    >
                      {{
                        currentUserData.role.includes("Admin")
                          ? "Admin"
                          : currentUserData.sustainabilityBusiness_name
                          ? currentUserData.sustainabilityBusiness_name
                          : currentUserData.goodCause_name
                          ? currentUserData.goodCause_name
                          : "User"
                      }}
                    </q-item-label>
                  </q-item-section>
                  <q-item-section avatar>
                    <q-icon name="arrow_drop_down" />
                  </q-item-section>
                </q-item>
              </q-list>
            </div>

            <!-- Menu -->
            <q-menu :offset="[-48, 0]" class="no-shadow">
              <q-list style="width: 167px">
                <q-item
                  clickable
                  v-close-popup
                  @click="$router.push('/settings/user')"
                >
                  <q-item-section> Settings </q-item-section>
                </q-item>
                <q-item
                  clickable
                  v-close-popup
                  @click="$store.dispatch('auth/logout')"
                >
                  <q-item-section> Log out </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </div>
        </div>
        <q-space />
      </q-toolbar>
    </q-header>

    <q-drawer
      :mini="miniState"
      v-model="drawer"
      show-if-above
      mini-to-overlay
      :width="200"
      :breakpoint="400"
      @mouseover="$store.dispatch('settings/changeMiniNav', false)"
      @mouseout="$store.dispatch('settings/changeMiniNav', true)"
      content-class="bg-white text-black column justify-between no-wrap shadow-4"
    >
      <q-scroll-area
        :thumb-style="{
          background: '#162c479c',
          opacity: 1,
          width: '8px',
          height: '8px',
          borderRadius: '20px',
        }"
        class="sidebar"
      >
        <q-list padding style="max-height: 100% !important">
          <div
            :key="`navLink_${index}`"
            v-for="(link, index) in displayedLinks"
          >
            <q-item
              dense
              v-if="
                !link.children &&
                !$route.params[link.hideOnPathID] &&
                (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              v-ripple
              clickable
              @click="routeTo(link)"
              :exact="!link.disableExact"
              active-class="activePage"
            >
              <q-item-section avatar>
                <q-icon
                  v-if="link.icon"
                  :color="link.iconColor ? link.iconColor : 'accent2'"
                  :name="link.icon"
                ></q-icon>
                <!-- <dataUpload /> -->
                <!-- <component v-bind:is="displayedLinks[1].customSVG"></component> -->
                <!-- {{ link.customSVG }} -->
                <keep-alive>
                  <component
                    v-bind:is="link.customSVG"
                    v-if="link.customSVG"
                  ></component>
                </keep-alive>

                <q-tooltip v-if="miniState">{{ link.text }}</q-tooltip>
              </q-item-section>
              <q-item-section class="nav-link" side>
                {{ link.text }}
              </q-item-section>
            </q-item>
            <q-expansion-item
              dense
              class="nav-link"
              v-else-if="
                !$route.params[link.hideOnPathID] &&
                (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              :ref="link.text"
              :group="link.text"
              :icon="link.icon"
              :label="link.text"
              expand-icon-class="activePage"
            >
              <q-list padding>
                <div
                  :key="`navLink_${childIndex}`"
                  v-for="(child, childIndex) in link.children"
                >
                  <q-item
                    dense
                    v-if="!child.children"
                    v-ripple
                    :to="child.to"
                    :exact="!link.disableExact"
                    active-class="activePage"
                  >
                    <q-item-section avatar>
                      <q-icon
                        v-if="link.icon"
                        :color="child.iconColor ? child.iconColor : 'accent2'"
                        :name="child.icon"
                      ></q-icon>
                      <component
                        :is="link.customSVG"
                        v-if="link.customSVG"
                      ></component>
                      <q-tooltip v-if="miniState">{{ link.text }}</q-tooltip>
                    </q-item-section>
                    <q-item-section side class="nav-link">
                      {{ child.text }}
                    </q-item-section>
                  </q-item>
                </div>
              </q-list>
            </q-expansion-item>
            <q-item v-else-if="link.spacer">
              <q-item> I AM A SPACER </q-item>
            </q-item>
          </div>

          <q-item
            v-if="currentUserData.impersonatingUser == true"
            v-ripple
            clickable
            @click="stopImpersonation"
          >
            <q-item-section avatar>
              <q-icon color="accent2" name="cancel"></q-icon>
            </q-item-section>

            <q-item-section> Stop Impersonation </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>

      <q-item class="col-grow"> </q-item>

      <q-item class="footer-text">
        <div
          v-if="!miniState"
          class="full-width no-pointer-events"
        >
          {{ currentYear }} © Oatas
        </div>
      </q-item>
    </q-drawer>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  // Icons
  import dashboard from "@/components/icons/dashboard.vue";
  import dataUpload from "@/components/icons/dataUpload.vue";
  import goalBuilder from "@/components/icons/goalBuilder.vue";
  import plans from "@/components/icons/plans.vue";
  import reporting from "@/components/icons/reporting.vue";
  import researchInsights from "@/components/icons/researchInsights.vue";
  import solutionDatabase from "@/components/icons/solutionDatabase.vue";
  import welder from "@/components/icons/welder.vue";

  export default {
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        miniState: "settings/miniNavState",
        selectedOutcome: "general/selectedOutcome",
        outcomesList: "outcomes/list",
      }),
      currentYear() {
        return moment().year();
      },
    },
    data: () => ({
      //outcome dropdown
      outcomesDropdown: false,

      drawer: false,

      // Navigation
      accMenuToggle: false,
      siteArea: "General",
      rolesAccess: {
        Admin: [
          "dashboard",
          // "questions",
          "solutions",
          "users",
          "wizard",
          // "tabs",
          // "sections",
          // "report",
          "outcomes",
          "sources",
          "basicGoals",
          "system",
          "management",
          // "community",
          // "marketplace",
          // "presentationMode",
          // "liveReport",
          // "spacer",
          "units",
          "articles",
          "articlesKeywords",
          "pageHelp",
          "actionTemplates",
          "business",
        ],
        SustainabilityBusiness: [
          "dashboard",
          "dataUpload",
          "solutionsDatabase",
          // "actionCentre",
          "myWorkspace",
          "reasearchAndInsights",
          "reporting",
          "myStoryboard",
          // "community",
          "myPlans",
        ],
        ImpactBusiness: ["dashboard"],
        GoodCause: ["dashboard"],
        user: ["dashboard"],
      },
      links: [
        {
          to: "/",
          customSVG: "dashboard",
          // icon: "fas fa-gauge",
          text: "Home",
          iconColor: "",
          name: "dashboard",
          siteArea: ["General"],
        },

        {
          to: "/outcome/1/dataUpload",
          customSVG: "dataUpload",
          text: "Data Upload",
          iconColor: "",
          name: "dataUpload",
          siteArea: ["General"],
        },
        {
          to: "/workspace/1",
          customSVG: "goalBuilder",
          text: "Goal Setting",
          name: "myPlans",
          siteArea: ["General"],
        },
        {
          to: "/outcomePlans/outcome/1/solutionWelder",
          customSVG: "welder",
          text: "Solution Welder",
          name: "myPlans",
          siteArea: ["General"],
        },

        {
          to: "/solutionsDatabase",
          customSVG: "solutionDatabase",
          text: "Solutions Database",
          name: "solutionsDatabase",
          siteArea: ["General"],
        },
        {
          to: "/actionCentre",
          icon: "fas fa-list-check",
          text: "Action Centre",
          name: "actionCentre",
          siteArea: ["General"],
        },
        {
          to: "/myPlans",
          customSVG: "plans",
          text: "My Plans",
          name: "myPlans",
          siteArea: ["General"],
        },
        {
          to: "/reports/data",
          customSVG: "reporting",
          text: "Reporting",
          name: "reporting",
          siteArea: ["General"],
        },

        {
          to: "/researchAndInsightsView",
          customSVG: "researchInsights",
          text: "Articles & Insights",
          name: "reasearchAndInsights",
          siteArea: ["General"],
        },
        // {
        //   to: "/workspace",
        //   icon: "mdi-chart-timeline-variant",
        //   text: "My Workspace",
        //   iconColor: "",
        //   name: "myWorkspace",
        //   siteArea: ["General"],
        // },
        // {
        //   to: "/report",
        //   icon: "mdi-text-box-multiple",
        //   text: "Reporting",
        //   iconColor: "",
        //   name: "report",
        //   siteArea: ["General"],
        // },
        // {
        //   to: "/",
        //   icon: "mdi-clipboard-text-multiple",
        //   text: "My Storyboard",
        //   name: "myStoryboard",
        //   siteArea: ["General"],
        // },
        // {
        //   to: "/",
        //   icon: "mdi-account-group",
        //   text: "Community",
        //   name: "community",
        //   siteArea: ["General"],
        // },
        // {
        //   name: "spacer",
        //   spacer: true,
        //   siteArea: ["General"],
        // },
        // {
        //   to: "/",
        //   icon: "",
        //   text: "Marketplace",
        //   name: "marketplace",
        //   siteArea: ["General"],
        // },
        // {
        //   to: "/",
        //   icon: "",
        //   text: "Presentation Mode",
        //   name: "presentationMode",
        //   siteArea: ["General"],
        // },
        // {
        //   to: "/",
        //   icon: "",
        //   text: "Live Report",
        //   name: "liveReport",
        //   siteArea: ["General"],
        // },
        {
          icon: "mdi-domain",
          text: "Business's",
          name: "business",
          siteArea: ["General"],
          to: "/business",
        },
        {
          icon: "mdi-account-tie",
          text: "Management",
          name: "management",
          siteArea: ["General"],
          children: [
            {
              to: "/users",
              icon: "",
              text: "Users",
              name: "users",
              siteArea: ["General"],
            },
            // {
            //   to: "/sections",
            //   icon: "",
            //   text: "Sections",
            //   iconColor: "",
            //   name: "sections",
            //   siteArea: ["General"],
            // },
            {
              to: "/sources",
              icon: "",
              text: "Sources",
              name: "sources",
              siteArea: ["General"],
            },
            {
              to: "/preWrittenGoals",
              icon: "",
              text: "Pre-written Goals",
              name: "basicGoals",
              siteArea: ["General"],
            },
            {
              to: "/units",
              icon: "",
              text: "Units",
              name: "units",
              siteArea: ["General"],
            },
            {
              to: "/solutions",
              icon: "",
              text: "Solutions",
              iconColor: "",
              name: "solutions",
              siteArea: ["General"],
            },
            {
              to: "/articles",
              icon: "",
              text: "Articles",
              iconColor: "",
              name: "articles",
              siteArea: ["General"],
            },
            {
              to: "/articlesKeywords",
              icon: "",
              text: "Article Keywords",
              iconColor: "",
              name: "articlesKeywords",
              siteArea: ["General"],
            },

            // {
            //   to: "/questions",
            //   text: "Questions",
            //   iconColor: "",
            //   name: "questions",
            //   siteArea: ["General"],
            // },
          ],
        },
        {
          icon: "mdi-cog-outline",
          text: "System",
          name: "system",
          siteArea: ["General"],
          children: [
            {
              to: "/outcomes",
              icon: "",
              text: "Outcomes",
              name: "outcomes",
              siteArea: ["General"],
            },
            {
              to: "/pageHelp",
              icon: "",
              text: "Page Help",
              name: "pageHelp",
              siteArea: ["General"],
            },
            {
              to: "/actionTemplates",
              icon: "",
              text: "Action Templates",
              name: "actionTemplates",
              siteArea: ["General"],
            },

            // {
            //   to: "/wizard",
            //   icon: "",
            //   text: "Wizard",
            //   iconColor: "",
            //   name: "wizard",
            //   siteArea: ["General"],
            // },
            // {
            //   to: "/tabs",
            //   icon: "",
            //   text: "Tabs",
            //   iconColor: "",
            //   name: "tabs",
            //   siteArea: ["General"],
            // },
          ],
        },
      ],
      displayedLinks: [],
    }),
    watch: {
      currentUserData: function () {
        this.setLinks();
        this.checkCurrentPagePerms();
      },
      siteArea: function () {
        this.setLinks();
      },
      $route: function () {
        this.setLinks();
        this.checkCurrentPagePerms();
      },
    },
    components: {
      dashboard,
      dataUpload,
      goalBuilder,
      plans,
      reporting,
      researchInsights,
      solutionDatabase,
      welder,
    },
    beforeCreate() {},
    mounted() {
      if (typeof this.currentUserData.role != "undefined") {
        this.setLinks();
      }
    },
    methods: {
      getOutcomeImage: getOutcomeImage,
      setLinks() {
        // Getting all views that the user has access too
        let currentRoleAccess = [];
        this.currentUserData.role.forEach((role) => {
          currentRoleAccess = currentRoleAccess.concat(this.rolesAccess[role]);
        });

        // Getting all Links that the user can view
        this.displayedLinks = this.checkLinkPerms(this.links, currentRoleAccess);
      },
      routeTo(link) {
        if (link.to == "/workspace") {
          this.$store.commit("general/setNextRoutePath", link.to);
          this.$router.push("/outcomeSelection");
        } else {
          this.$router.push(link.to);
        }
      },
      checkLinkPerms(links, currentRoleAccess) {
        let newLinks = [];
        links.forEach((link) => {
          let newLink = JSON.parse(JSON.stringify(link));
          if (
            currentRoleAccess.includes(link.name) &&
            link.siteArea.includes(this.siteArea)
          ) {
            if (newLink.idInPath) {
              let regex = /:.*/;
              let value = newLink.to.match(regex)[0].split("/")[0];

              newLink.to = newLink.to.replace(
                value,
                this.$route.params[value.substring(1)]
              );
            }

            if (link.children) {
              newLink.children = this.checkLinkPerms(
                link.children,
                currentRoleAccess
              );
            }
            newLinks.push(newLink);
          }
        });
        return newLinks;
      },
      switchSites() {
        window.open("https://admin.upstream.nz");
      },
      toggleNav() {
        if (this.$q.screen.lt.sm) {
          this.drawer = !this.drawer;
        } else {
          this.$store.dispatch("settings/togglMiniNav");
        }
      },

      checkCurrentPagePerms() {
        if (
          this.$route.meta &&
          this.$route.meta.roles &&
          this.$route.meta.roles.Admin &&
          this.currentUserData &&
          this.currentUserData.role &&
          !this.currentUserData.role.includes("Admin")
        ) {
          this.$router.push("/");
        }
      },
    },
  };
</script>


<style lang="scss">
  .toolbar {
    background-color: white;
    color: black;
    min-height: 60px !important;

    p {
      color: #9a9aaf;
      margin: 0;
    }

    .accText {
      border-radius: 5px;
    }

    .accText:hover {
      background-color: #e8e8e8;
      color: black;
    }

    .accText .userRole {
      color: #9a9aaf;
    }

    .accText:hover .userRole {
      color: black;
    }
  }

  // For shadow

  .navbarLogo {
    height: 60px;
    width: 200px; // 1px less to account for border-right
    background-color: $accent2;
    cursor: pointer;

    p {
      position: absolute;
      color: white;
    }

    p:nth-child(1) {
      font-size: 1.8rem;
      font-weight: bold;
      top: 0px;
      left: 30px;
    }

    p:nth-child(2) {
      font-size: 0.8rem;
      font-weight: 300;
      // bottom: 20px;
      top: 30px;
      left: 60px;
    }
  }

  .navbarLogoMobile {
    height: 60px;
    width: 57px; // 1px less to account for border-right
    background-color: $accent2;
    cursor: pointer;

    p {
      position: absolute;
      color: white;
    }

    p:nth-child(1) {
      font-size: 1.8rem;
      font-weight: bold;
      top: 0px;
      left: 30px;
    }

    p:nth-child(2) {
      font-size: 0.8rem;
      font-weight: 300;
      // bottom: 20px;
      top: 30px;
      left: 60px;
    }
  }

  .btnDropdown {
    position: absolute !important;
    width: 200px !important;
    height: 60px !important;
    border-radius: 0 !important;
    z-index: 1;
  }

  .btnDropdownMobile {
    position: absolute !important;
    width: 57px !important;
    height: 60px !important;
    border-radius: 0 !important;
    z-index: 1;
  }

  .dropdownLogo {
    width: 100%;
    height: 60px;
    p:nth-child(2) {
      font-size: 0.8rem;
      font-weight: 300;
      bottom: 5px;
      left: 60px;
    }
  }

  .q-header {
    min-height: 60px;
  }

  .sidebar {
    height: calc(100vh - 60px) !important;
    // padding-top: 20px;
    // border-right: 1px solid #ddd;

    .smallImage {
      width: 40px;
      margin: auto;
    }
  }

  .searchbar_menu {
    width: 250px;
    border-radius: 0px 0px 40px 40px !important;
  }

  .searchbar {
    height: 50px;
    width: 280px;
    background-color: #ffffff7e !important;
    border-radius: 120px !important;
    margin-right: 20px;
  }
  .searchbar_text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
  }

  .nav-link {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    align-items: center;
    letter-spacing: -0.02em;
    color: #162c47;
  }

  .footer-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 9.91758px;
    line-height: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #162c47;
  }
</style>
